import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AccordionWithCheckboxes from './AccordionWithCheckboxes';
import Icon from '@components/custom/Icon';

import { setAccordionState } from '@sm/store/accordionSlice';

const Actions = (props) => {
  const dispatch = useDispatch();

  const { filters, handleCheckboxChange, selectedOptions, showTable, setShowTable, type } = props;

  const [showFilter, setShowFilter] = useState(false);

  function closeFilter() {
    dispatch(setAccordionState({
      [`${type}OpenIndex`]: null
    }));
    setTimeout(() => {
      setShowFilter(false);
    }, 300);
  };

  return (
    <div className='d-flex align-items-center'>
      <div className='filter-btn position-relative'>
        <div className='d-flex icon-btn-wrap' onClick={ () => setShowFilter(true) }>
          <Icon name='discover_tune' style={ { rotate: '90deg' } } />
        </div>
        <div className={ `filter ${showFilter ? 'show' : 'hidden'}` }>
          <div className='header d-flex justify-content-between align-items-center'>
            Filters
            <Icon
              name='close'
              color='#5b5b5b'
              size={ 16 }
              style={ { marginRight: 0, cursor: 'pointer' } } onClick={ () => closeFilter() }
            />
          </div>
          <div className='body'>
            <AccordionWithCheckboxes
              id={ type }
              filters={ filters }
              selectedOptions={ selectedOptions }
              handleCheckboxChange={ handleCheckboxChange }
            />
          </div>
        </div>
      </div>
      <div className='d-flex icon-btn-wrap' onClick={ () => setShowTable(prev => !prev) }>
        <Icon name={ showTable ? 'collapse_all' : 'expand_all' } />
      </div>
    </div>
  );
};

export default Actions;